<template>
    <b-container class="m-0 p-0">
        <!-- Gestion du coût unitaire -->
        <b-row class="w-100 no-gutters py-1">
            <b-card class="p-2 w-100 bg-white" body-class="d-flex flex-column border p-0 my-0 ">
                <b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100 bg-white">
                    <b-row align-v="center">
                        <b-col>
                            <!-- UnitCost : Coût unitaire -->
                            <small class="pr-3">{{$t('UnitCost')}}</small>
                        </b-col>
                    </b-row>
                </b-card-header>

                <b-card-body class="py-0 bg-white">
                    <!-- Type de synthèse -->
                    <b-row class="py-0 mb-2">
                        <b-button v-for="syn in filteredSynthesis()" :key="syn.Id"
                                  @click="dataValue.Synthesis = syn.Id; $emit('ChangeConfigCommonWorkDataEvent', 0);"
                                  :pressed="dataValue.Synthesis === syn.Id"
                                  size="sm" :disabled="checkSynthesisType(syn.Id)"
                                  class="mx-1 mb-1 flex-grow-1" variant="outline-gray-dark text-black">
                            {{syn.Label}}
                        </b-button>
                    </b-row>

                    <!-- Type Production / Flux -->
                      <!-- Flow : Flux -->
                    <template v-if="filteredFlow().length > 1">
                        <b-row class="font-weight-bold">{{$t('Flow')}}</b-row>
                        <b-row>
                            <b-button v-for="flow in filteredFlow()" :key="flow.Id"
                                      @click="dataValue.Flow = flow.Id; $emit('ChangeConfigCommonWorkDataEvent', 0);"
                                      :pressed="dataValue.Flow === flow.Id"
                                      size="sm" :disabled="checkFlowType(flow.Id)"
                                      class="mx-1 mb-1 flex-grow-1" variant="outline-gray-dark text-black">
                                {{flow.Label}}
                            </b-button>
                        </b-row>
                    </template>

                    <!-- Numérateur -->
                    <b-row align-v="center" class="mb-2">
                        <b-col cols="4">
                            <!-- Numerator : Numérateur -->
                            <label class="mb-0">{{$t('Numerator')}}</label>
                        </b-col>
                        <b-col>
                            <b-form-select :id="$id('rangeYEnd')" :options="sNumeratorList" value-field="Id"
                                           @change="$emit('ChangeConfigCommonWorkDataEvent', 0);"
                                           text-field="Label" plain v-model="dataValue.Numerator" class="w-100" />
                        </b-col>
                    </b-row>

                    <!-- Dénominateur -->
                    <b-row align-v="center" class="mb-2">
                        <b-col cols="4">
                            <!-- Denominator : Dénominateur -->
                            <label class="mb-0">{{$t('Denominator')}}</label>
                        </b-col>
                        <b-col>
                            <b-form-select :id="$id('rangeYEnd')" :options="sDenominatorList" value-field="Id"
                                           @change="$emit('ChangeConfigCommonWorkDataEvent', 0);"
                                           text-field="Label" plain v-model="dataValue.Denominator"
                                           class="w-100" @input="selectDefaultExpendable"/>
                        </b-col>
                    </b-row>

                    <!-- Liste des énergies affiché si dénominateur est Conso / Livraison -->
                    <template v-if="dataValue.Denominator == 'Consumption'">
                        <hr class="mb-2 bg-gray" />
                        <b-row align-v="center">
                            <b-button v-for="expendable in filteredExpendable()" :key="expendable.Id"
                                      @click="dataValue.FilterExpendables = expendable.Id.toString(); $emit('ChangeConfigCommonWorkDataEvent', 0);"
                                      :pressed="dataValue.FilterExpendables === expendable.Id.toString()"
                                      pill size="sm" class="mx-1 mb-2 flex-grow-1"
                                      variant="border border-gray text-black bg-gray-light">
                                {{ expendable.Label }}
                            </b-button>
                        </b-row>
                    </template>
                </b-card-body>
            </b-card>
        </b-row>

        <!-- Gestion des Filtres / Répartitions -->
        <b-row class="w-100 no-gutters py-1">
            <b-card class="p-2 w-100 bg-white" body-class="d-flex flex-column border p-0 my-0 ">
                <b-card-header header-tag="header" class="text-center font-weight-bold py-1 mx-0 w-100 bg-white">
                    <b-row align-v="center">
                        <b-col>
                            <!-- FiltersDistributions : Filtres / Répartitions -->
                            <small class="pr-3">{{$t('FiltersDistributions')}}</small>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-card-body class="py-0 bg-white">
                    <!-- Répartition -->
                    <b-row align-v="center" class="mb-2">
                        <b-col cols="3">
                            <!-- Distribution : Répartition -->
                            <label class="m-0">{{$t('Distribution')}}</label>
                        </b-col>
                        <b-col>
                            <b-form-select id="distributions" :options="filteredDistributions()" value-field="Id"
                                           text-field="Label" plain
                                           v-model="dataValue.Distribution" class="w-100"/>
                        </b-col>
                    </b-row>

                    <hr class="my-2 text-muted" />

                    <!-- Filtres -->
                    <b-row class="justify-content-between">
                        <!-- Filters : Filtres -->
                        <b-col class="pb-1 pl-2 font-weight-bold">{{$t('Filters')}}</b-col>
                        <b-col class="text-right">
                            <!-- Fill : Renseigner -->
                            <b-link @click="filterVisible = true;" :class="'text-' + Variant">{{$t('Fill')}}</b-link>
                        </b-col>
                    </b-row>

                    <b-row>
                         <!-- FiltersSelected : {count} filtres sélectionnés -->
                        <b-col class="text-muted">
                            {{ $tc('SelectedFilters', dataValue.Filters.length, { n : dataValue.Filters.length}) }}
                        </b-col>
                    </b-row>

                    <!-- Modale de sélection de filtres -->
                    <Filters v-if="filterVisible" :Visible.sync="filterVisible" :PerimeterList.sync="perimeterList"
                             :DataType.sync="dataValue.Numerator" :Distribution.sync="dataValue.Distribution" :Purposes.sync="dataValue.FilterPurposes"
                             :Uses.sync="dataValue.FilterUsages" :Expendable.sync="dataValue.FilterExpendables" :Costs.sync="dataValue.FilterCostDetails" :Providers.sync="dataValue.FilterProviders"
                             :Tariffs.sync="dataValue.FilterTariffs" :Contracts.sync="dataValue.FilterContracts" :SModel.sync="dataValue.BudgetModelId"
                             :SFormulaCode.sync="dataValue.FilterBudgetModel" :Owner.sync="dataValue.FilterOwner" :ObjectType.sync="dataValue.FilterObjectType"
                             :SubscriptionHolder.sync="dataValue.FilterSubscriptionHolder" :PayingInvoice.sync="dataValue.FilterPayingInvoice"
                             :SelectedFilters.sync="dataValue.Filters" :Variant="Variant" />

                    <hr class="my-2 text-muted" />

                    <!-- Options Avancées-->
                    <b-row class="justify-content-between">
                        <b-col class="pb-1 pl-2 font-weight-bold">{{$t('AdvancedSettings')}}</b-col>
                        <b-col class="text-right">
                            <b-link @click="optionVisible = true;" :class="'text-' + Variant">{{$t('Fill')}}</b-link>
                        </b-col>
                    </b-row>

                    <b-row>
                         <!-- FiltersSelected : {count} filtres sélectionnés -->
                        <b-col class="text-muted">
                            {{ $tc('SelectedSettings', selectedSettings.length, { n : selectedSettings.length}) }}
                        </b-col>
                    </b-row>

                    <!-- Modale d'options avancées -->
                    <AdvancedSettings v-if="optionVisible" :Visible.sync="optionVisible" :HandleByMetersVisible="true" :IsHandleByMeters.sync="dataValue.IsHandleByMeters" :SynthesisType="dataValue.Synthesis"
                        :DisplaySettingsVisible="true" :SelectedSettings.sync="selectedSettings" :Variant="Variant" />


                </b-card-body>
            </b-card>
        </b-row>
    </b-container>
</template>
<script lang="ts">
import {Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import Component from 'vue-class-component';
import draggable from 'vuedraggable';
import HscMenuStyleCustom from '@/components/commons/HscMenuStyleCustom';
import ListItem from "@/types/fields/ListItem";
import Multiselect from 'vue-multiselect';
import EnumItem from '@/types/fields/EnumItem';
import Filters from "./Datablock/Filters.vue";
import UnitCostData from '@/types/Config/UnitCostData';
import AdvancedSettings from './Datablock/AdvancedSettings.vue';
/** Traductions */
import locales from "./locales/DataBlockUnitCost.json";

/** Block de données de paramétrage */
@Component({
    components: {
        Filters,
        'hsc-menu-style-custom': HscMenuStyleCustom("secondary"),
        draggable,
        Multiselect,
        AdvancedSettings
    },
    i18n: { messages: locales }
    
})
export default class DataBlockUnitCost extends Vue {
    /** Variant de couleur à appliquer sur le composant */
    @Prop({ default: () => "secondary"})
    public Variant!: string;

    /** Getter pour obtenir une liste */
    @Getter('GetListItems')
    private listItems!: (listName: string) => ListItem[];

    /** Getter pour obtenir une liste d'énumération */
    @Getter('GetListEnums')
    private listEnums!: (listName: string) => EnumItem[];

    /** Getter pour obtenir une liste filtrée selon le périmètre de l'utilisateur */
    @Getter('GetPerimeterItems')
    private perimeterItems!: (listName: string) => any[];

    /** Index du bloc de données */
    @Prop()
    public Index!: number;

    /** Nom de la fonctionnalité où se trouve le DataBlock (gestion affichage diff.) */
    @Prop()
    public Feature!: string;

    /** Données manipulées localement par le bloc de données */
    @PropSync('DataValue')
    public dataValue!: UnitCostData;

    //#region Type de synthèse

    @Prop()
    public sNumeratorList!: { Id: string, Label: string }[];

    @Prop()
    public sDenominatorList!: { Id: string, Label: string }[];

    /** Permet d'obtenir la liste des synthèses pour UnitCost */
    private filteredSynthesis() {
        return this.listEnums('SynthesisType|' + this.Feature).filter(x => x.Id.includes("Invoice") || x.Id.includes("Budget"));
    }

    /**
     * Filtre la liste des synthèses selon la liste du périmètre de l'utilisateur
     * @param syn
     */
    private checkSynthesisType(syn) {
        return this.perimeterItems("SynthesisType") ? !(this.perimeterItems("SynthesisType").includes(syn)) : false;
    }

    //#endregion Type de synthèse

    //#region Flux

    /** Permet d'obtenir la liste des synthèses pour UnitCost */
    private filteredFlow() {
        return this.listEnums('Flow|' + this.Feature);
    }

    /**
     * Filtre la liste des synthèses selon la liste du périmètre de l'utilisateur
     * @param syn
     */
    private checkFlowType(syn) {
        return this.perimeterItems("Flow") ? !(this.perimeterItems("Flow").includes(syn)) : false;
    }

    //#endregion Flux

    //#region Répartitions

    /** Chaine des listes à récupérer selon le périmètre de l'utilisateur */
    private perimeterList: string = "Expendable,UsageType,Purpose,SynthesisType,Provider,Tariff,Contract,Owner,SubscriptionHolder,ObjectType,PayingInvoice,Flow";

    /** Liste des distributions filtrées selon la feature */
    private filteredDistributions() {
        let filteredDistributions: EnumItem[] = [...this.listEnums("SynthesisDistribution|" + this.Feature )];

        // Si dénominateur est Conso/Livraison, on ajoute Répartition 'Aucune' et on supprime 'Énergie et fluide'
        if (this.dataValue.Denominator == 'Consumption'){
            filteredDistributions.unshift({Id: "None", Label: this.$t('None').toString(), Extras: {}}); // Label: Aucune
            filteredDistributions = filteredDistributions.filter(x => x.Id != 'Expendable');
        }

        return filteredDistributions;
    }

    //#endregion Répartitions

    //#region Energies

    /** Liste des energies sélectionnées pour le filtre */
    private filterEnergies: { Id: number, Label: string }[] = [];

    /** Permet de récupérer la liste des énergies sélectionnées */
    @Watch('dataValue.FilterExpendables', { immediate: true })
    protected updateFilterExpendable() {
        if (this.dataValue.FilterExpendables){
            this.filterEnergies = this.listItems("Expendable").filter(x => (this.dataValue.FilterExpendables.split(","))
                .includes(x.Id.toString()));
        }
    }

    /**
     * Permet de sélectionner l'énergie par défaut selon dénominateur
     * @param denominator
     */
    private selectDefaultExpendable(denominator) {
        console.debug("UnitCost - selectDefaultExpendable - value", denominator);

        // Si aucun filtre d'énergies existe au changement de dénominateur
        if(!this.dataValue.Filters.find(x => x.Name == 'Expendable')){
            this.dataValue.FilterExpendables = null;
        }

        // Si dénominateur sélectionné est Conso/Livraison
        if(denominator === 'Consumption'){
            this.dataValue.FilterExpendables = this.perimeterItems('Expendable')[0].toString();

            // Si filtres énergies existe, on le supprime
            if(this.dataValue.Filters.find(x => x.Name == 'Expendable')){
                let index = this.dataValue.Filters.findIndex(x => x.Name == 'Expendable');
                this.dataValue.Filters.splice(index, 1);
            }

            // Si distribution sélectionnée était Énergie et fluide → passe à aucune
            if(this.dataValue.Distribution == "Expendable")
                this.dataValue.Distribution = "None";
        }

        // Si le dénominateur n'est plus Conso/Livraison et que la répartition sélectionnée est "Aucune", on prend la premiere repartition sélectionnée
        if (denominator != 'Consumption' &&  this.dataValue.Distribution == "None") {
            this.dataValue.Distribution = this.listEnums("SynthesisDistribution|" + this.Feature).at(0).Id;
        }
    }

    /** Permet de filtrer la liste des énergies disponibles */
    private filteredExpendable() {
        let filterExpendables: { Id: number, Label: string }[] = [];
        filterExpendables = this.listItems('Expendable').filter(x => (this.perimeterItems('Expendable').includes(x.Id)));

        return filterExpendables;
    }

    //#endregion Energies

    //#region Filtres

    /** Indique si on affiche la modale de selection de filtres */
    private filterVisible: boolean = false;

    //#endregion Filtres

    //#region Options avancées
    private optionVisible: boolean = false;

    /** Liste des options sélectionnées */
    public selectedSettings : {Name: string, Values : string}[] = [];

    /** Permet de récupérer les options avancés sélectionnés dans la configuration + watcher sur sélection d'un masque de configuration */
    @Watch('SelectedMask')
    private getSelectedSettings(){
        this.selectedSettings = [];

        if(this.dataValue.IsHandleByMeters){
                this.dataValue.IsHandleByMeters = true;
                this.selectedSettings.push({Name: "isHandleByMeters", Values: ""});
            }
    }

    //#endregion Options avancées


    mounted() {
        /** Chargement des options sélectionnées */
        this.getSelectedSettings();
    }
}
</script>
<style scoped>

</style>